import React from 'react';
import SidebarLayout from './SidebarLayout'; // Import the generic layout

// Simple wrapper for the left sidebar layout
const SidebarLeftLayout = (props) => {
  return <SidebarLayout {...props} sidebarPosition="left" />;
};

export default SidebarLeftLayout; 